export enum ErrorCode {
  NOT_EXIST,
  NOT_PUBLISHED,
}
